package de.ohhhmhhh.frontend.admin.ui.screens.text.edit

import androidx.compose.runtime.Composable
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import de.ohhhmhhh.backend.models.model.text.StaticTextTypeEntity
import de.ohhhmhhh.frontend.admin.ui.components.buttons.Button
import de.ohhhmhhh.frontend.admin.ui.components.buttons.ButtonType
import de.ohhhmhhh.frontend.admin.ui.components.container.Page
import de.ohhhmhhh.frontend.admin.ui.components.container.Row
import de.ohhhmhhh.frontend.admin.ui.components.inputs.EditorController
import de.ohhhmhhh.frontend.admin.ui.components.inputs.EditorInput
import de.ohhhmhhh.frontend.admin.ui.components.inputs.MultilineTextInput
import de.ohhhmhhh.frontend.admin.ui.components.inputs.TextInput
import de.ohhhmhhh.frontend.admin.ui.components.other.LabeledSelect
import de.ohhhmhhh.frontend.admin.ui.components.other.Spacer
import de.ohhhmhhh.frontend.admin.ui.components.other.SuccessMessage
import de.ohhhmhhh.frontend.admin.ui.screens.article.edit.compress
import org.jetbrains.compose.web.attributes.disabled

@Composable
fun TextEditPageContent(
    state: TextEditState,
    setTitle: (String) -> Unit,
    setContent: (String) -> Unit,
    setRevision: (String) -> Unit,
    save: () -> Unit,
    open: () -> Unit,
    back: () -> Unit
) {
    val controller = remember { EditorController() }
    Page("Text bearbeiten", onBack = back, options = {
        LabeledSelect(state.revisions, state.revision, setRevision)
    }) {
        TextInput("Titel", state.title, onChange = setTitle)
        Spacer()
        when (state.type) {
            StaticTextTypeEntity.PLAIN -> MultilineTextInput(state.content, setContent = setContent)
            StaticTextTypeEntity.STRUCTURED -> EditorInput("Inhalt", state.content, controller)
            null -> Unit
        }
        Spacer()
        Row {
            Button("Öffnen", attrs = { if (state.savable) disabled(); classes("ms-auto") }, onClick = open)
            Button(
                title = if (state.savable) "Speichern" else "Falsche Revision",
                type = ButtonType.HIGHLIGHT,
                attrs = { if (!state.savable) disabled() },
                onClick = {
                    when (state.type) {
                        StaticTextTypeEntity.PLAIN -> save()
                        StaticTextTypeEntity.STRUCTURED -> controller.save().then {
                            setContent(it.compress())
                            save()
                        }

                        null -> Unit
                    }
                }
            )
        }
    }

    if (state.saved != null) {
        val mutableState = remember(state.saved) { mutableStateOf(true) }
        SuccessMessage("Artikel gespeichert", mutableState)
    }
}